"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _themeContants = require("../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Steps =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Steps, _React$Component);

  function Steps(props, context) {
    var _this;

    _classCallCheck(this, Steps);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Steps).call(this, props, context));
    _this.resolve = _this.resolve.bind(_assertThisInitialized(_this));
    _this.next = _this.next.bind(_assertThisInitialized(_this));
    _this.previous = _this.previous.bind(_assertThisInitialized(_this));
    _this.setStep = _this.setStep.bind(_assertThisInitialized(_this));
    _this.navigate = _this.navigate.bind(_assertThisInitialized(_this));
    _this.set = _this.set.bind(_assertThisInitialized(_this));
    _this.state = {
      stepIndex: props.start,
      direction: 0,
      values: props.initialValues
    };
    return _this;
  }

  _createClass(Steps, [{
    key: "next",
    value: function next() {
      this.navigate(1);
    }
  }, {
    key: "previous",
    value: function previous() {
      this.navigate(-1);
    }
  }, {
    key: "navigate",
    value: function navigate(diretion) {
      var stepIndex = this.state.stepIndex;
      var index = stepIndex + diretion;
      this.setStep(index);
    }
  }, {
    key: "setStep",
    value: function setStep(index) {
      var stepIndex = this.state.stepIndex;
      var stepCount = this.props.steps.length;
      var loop = this.props.loop;
      var direction = index > stepIndex ? 1 : -1;

      if (index >= stepCount) {
        if (!loop) {
          throw new Error("Trying to increment steps beyond data. Not allowed. Enable loop if intended");
        } else {
          index = 0;
        }
      } else if (index < 0) {
        if (!loop) {
          throw new Error("Trying to increment steps beyond data. Not allowed. Enable loop if intended");
        } else {
          index = stepCount - 1;
        }
      }

      this.setState({
        stepIndex: index,
        direction: direction
      });
    }
  }, {
    key: "resolve",
    value: function resolve(index, steps) {
      var stepCount = steps.length;
      var current = stepCount > index ? steps[index] : null;
      var hasNext = (steps.length > index || this.props.loop) && (current.validator ? current.validator() : true);
      var hasPrevious = index > 0 || this.props.loop;
      var progress = (index + 1) / stepCount;
      return {
        stepIndex: index,
        stepCount: stepCount,
        progress: progress,
        current: current,
        steps: steps,
        hasNext: hasNext,
        hasPrevious: hasPrevious
      };
    }
  }, {
    key: "set",
    value: function set(value) {
      var _this2 = this;

      this.setState({
        values: _objectSpread2({}, this.state.values, {}, value)
      }, function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(_this2.state.values);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var next = this.next,
          previous = this.previous,
          navigate = this.navigate,
          setStep = this.setStep;
      var _this$state = this.state,
          values = _this$state.values,
          direction = _this$state.direction;
      var state = this.resolve(this.state.stepIndex, this.props.steps);
      return this.props.children(_objectSpread2({}, state, {
        direction: direction,
        values: values,
        setState: this.set,
        next: next,
        previous: previous,
        navigate: navigate,
        setStep: setStep
      }));
    }
  }]);

  return Steps;
}(_react["default"].Component);

var _default = Steps;
exports["default"] = _default;
Steps.propTypes = {
  children: _propTypes["default"].any.isRequired,
  start: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  steps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    component: _themeContants.commonPropTypes.children,
    validator: _propTypes["default"].func,
    data: _propTypes["default"].any
  })),
  initialValues: _propTypes["default"].any
};
Steps.defaultProps = {
  start: 0,
  loop: false,
  steps: [],
  initialValues: {}
};